import Store2LineIcon from "remixicon-react/Store2LineIcon";
import FileList2LineIcon from "remixicon-react/FileList2LineIcon";
import StoreLineIcon from "remixicon-react/StoreLineIcon";
import HeartLineIcon from "remixicon-react/HeartLineIcon";
import EyeLineIcon from "remixicon-react/EyeLineIcon";
import UserLineIcon from "remixicon-react/UserLineIcon";
import Settings3FillIcon from "remixicon-react/Settings3FillIcon";
import Refund2LineIcon from "remixicon-react/Refund2LineIcon";

export const profileDropdownLinks = [
  {
    label: "shops",
    href: "/shop",
    icon: <Store2LineIcon size={24} />,
    requiredAuth: false,
  },
  {
    label: "order.history",
    href: "/orders",
    icon: <FileList2LineIcon size={24} />,
    requiredAuth: true,
  },
  {
    label: "refund.orders",
    href: "/orders/refunds",
    icon: <Refund2LineIcon size={24} />,
    requiredAuth: true,
  },
  {
    label: "liked.shops",
    href: "/liked/shops",
    icon: <StoreLineIcon size={24} />,
    requiredAuth: false,
  },
  {
    label: "liked.products",
    href: "/liked/products",
    icon: <HeartLineIcon size={24} />,
    requiredAuth: false,
  },
  {
    label: "viewed.products",
    href: "/product/viewed",
    icon: <EyeLineIcon size={24} />,
    requiredAuth: false,
  },
  {
    label: "profile.settings",
    href: "/profile",
    icon: <UserLineIcon size={24} />,
    requiredAuth: true,
  },
  {
    label: "site.settings",
    href: "/settings",
    icon: <Settings3FillIcon size={24} />,
    requiredAuth: false,
  },
];
